import React from 'react'

import { withTranslation } from 'react-i18next'

import './VideoPlayer.css'

const VideoPlayer = ({ t, videoUrl, title }) => (
    <div className="video-player">
        <h5>{title}</h5>
        <video className="video-player__player" width="320" height="240" controls>
            <source src={videoUrl} type="video/mp4" />
            <source src={videoUrl} type="video/ogg" />
            {t('videoGenericMessage')}
        </video>
    </div>
)

export default withTranslation()(VideoPlayer)
